import React from 'react'
import {
  AutoCompleterV3,
  AutoCompleterConfig
} from '../../../components/_WMS/AutoCompleterV3'
import { ComponentProps } from '../../../components/_WMS/FilterComponent/types'
import { createFilterValueWithDisplay } from '../../../types/filters'
import { ApiConfig } from '../../../config/api'
import { VasRule } from '../../../interfaces/VasRule/VasRule'

const vasRuleConfig: AutoCompleterConfig<VasRule> = {
  searchEndpoint: `${ApiConfig.VasRuleApi}/searchByName`,
  searchParam: 'searchText',
  keyField: 'vasRuleId',
  displayField: 'name',
  minSearchLength: 3,
  debounceMs: 300,
  pageSize: 10
}

export const VasRuleAutoCompleter: React.FC<ComponentProps> = ({
  value,
  onChange,
  fullWidth = true,
  transformForBackend,
  transformForDisplay
}) => {
  const [selectedVasRule, setSelectedVasRule] = React.useState<VasRule | null>(
    null
  )

  // Sincronizar con el valor externo cuando cambie
  React.useEffect(() => {
    if (value && value !== selectedVasRule?.vasRuleId.toString()) {
      // Si hay un valor pero no coincide con el seleccionado, limpiar
      setSelectedVasRule(null)
    }
  }, [value, selectedVasRule])

  const handleVasRuleChange = (vasRule: VasRule | null) => {
    setSelectedVasRule(vasRule)

    // Si hay transformadores disponibles, usar el enfoque JSON para compatibilidad con FilterComponent
    // Si no, usar el valor simple (para casos donde se use fuera de FilterComponent)
    let eventValue = ''
    if (vasRule) {
      if (transformForBackend && transformForDisplay) {
        // Usar función tipada para FilterComponent
        eventValue = createFilterValueWithDisplay(
          vasRule.vasRuleId,
          `${vasRule.name} (${vasRule.typeVasName})`
        )
      } else {
        // Usar valor simple para otros casos
        eventValue = vasRule.vasRuleId.toString()
      }
    }

    const syntheticEvent = {
      target: {
        value: eventValue,
        name: 'vasRuleId'
      }
    } as React.ChangeEvent<HTMLInputElement>

    onChange(syntheticEvent)
  }

  const renderOption = (vasRule: VasRule) => (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start'
      }}
    >
      <div style={{ fontWeight: 'bold' }}>{vasRule.name}</div>
      <div style={{ fontSize: '0.875rem', color: '#666' }}>
        Tipo: {vasRule.typeVasName}
      </div>
    </div>
  )

  const renderValue = (vasRule: VasRule) =>
    `${vasRule.name} (${vasRule.typeVasName})`

  return (
    <AutoCompleterV3<VasRule>
      config={vasRuleConfig}
      value={selectedVasRule}
      onChange={handleVasRuleChange}
      placeholder='Buscar Regla VAS...'
      renderOption={renderOption}
      renderValue={renderValue}
      width={fullWidth ? '100%' : 300}
    />
  )
}
